import _objectWithoutProperties from "babel-runtime/helpers/objectWithoutProperties";
import React from "react";
import styled, { css } from "styled-components";
import { getIf, get } from "../../style/util";

var Button = styled(function (_ref) {
  var primary = _ref.primary,
      backgroundColor = _ref.backgroundColor,
      textColor = _ref.textColor,
      props = _objectWithoutProperties(_ref, ["primary", "backgroundColor", "textColor"]);

  return React.createElement("button", props);
}).withConfig({
  componentId: "s1qc65ik-0"
})(["display:inline-block;text-decoration:none;", ";", ";", ";"], get("style.button"), getIf("primary", "style.buttonPrimary"), getIf("disabled", "style.buttonDisabled"));
export { Button };
//# sourceMappingURL=style.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/components/Button/style.js
// module id = 431
// module chunks = 0